import React, { createContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useVariant, variant1, variant2, variant3, variant4, variant5 } from './VariantContext';

export const ConfigurationContext = createContext({});

export const ConfigurationProvider = ({ children }) => {
  const variant = useVariant();
  let showQuickLinks = false;
  let shouldUseDealerFromCookie = false;

  switch (variant) {
    case variant1:
      showQuickLinks = true;
      shouldUseDealerFromCookie = true;
      break;

    case variant2:
      showQuickLinks = true;
      shouldUseDealerFromCookie = true;
      break;

    case variant4:
      shouldUseDealerFromCookie = true;
      break;

    case variant3:
    case variant5:
    default:
      break;
  }

  const config = useMemo(
    () => ({
      showQuickLinks,
      shouldUseDealerFromCookie,
    }),
    [variant],
  );

  return <ConfigurationContext.Provider value={config}>{children}</ConfigurationContext.Provider>;
};

ConfigurationProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
